// extracted by mini-css-extract-plugin
module.exports = {"export-container":"TableExport_export-container__1zlUq","export-btn":"TableExport_export-btn__S4TDE"};